import { PhotoId } from '@connect-assistance/connect-react-components-lib';
import { DocsQuestionsState } from 'components/docsQuestions/DocsQuestions';
import { Photo, AppContext, PhotoSections } from 'context/interfaces';
import { sections, BRAND } from 'shared/utils';
interface PhotoBySectionsType {
	[key: string]: Photo[];
}

interface CompletedSectionType {
	[key: string]: boolean;
}

interface RequiredSectionType {
	[key: string]: boolean;
}

export const hasRequiredPhotos = (ctx: AppContext): boolean => {
	const { photos } = ctx;
	const completed = !photos.some((p) => p.required && !p.awsUrl);
	return completed;
};

export const getPhotoSections = (documentsValidation?: DocsQuestionsState[] | null | undefined): PhotoSections[] => {
	return sections[BRAND].map((section) => {
		let currentSection = section;

		if (documentsValidation && currentSection.sectionId === 'documents') {
			let currentPhotoIds = currentSection.photosIds;

			const hasDriverLicense = documentsValidation.some(
				(doc) => doc.documentType === 'drivers_license' && doc.selectableValue === true
			);
			const hasCarRegistration = documentsValidation.some(
				(doc) => doc.documentType === 'car_registration' && doc.selectableValue === true
			);

			if (!hasDriverLicense) {
				[
					PhotoId.INSURED_LICENSE_PR,
					PhotoId.INJURED_LICENSE_PR,
					PhotoId.INJURED_LICENSE_CR,
					PhotoId.INSURED_LICENSE_CR,
					PhotoId.INSURED_LICENSE_PA,
					PhotoId.INJURED_LICENSE_PA,
				].forEach((photoKey: string) => {
					currentPhotoIds = currentPhotoIds.filter((id) => id !== photoKey);
				});
			}

			if (!hasCarRegistration) {
				[PhotoId.INSURED_VEHICLE_LICENSE_PR, PhotoId.INJURED_VEHICLE_LICENSE_PR].forEach((photoKey: string) => {
					currentPhotoIds = currentPhotoIds.filter((id) => id !== photoKey);
				});
			}

			documentsValidation.forEach((doc) => {
				if (doc.documentType !== 'drivers_license' && doc.documentType !== 'car_registration') {
					currentPhotoIds.push(doc.documentType);
				}
			});
			currentSection = { ...currentSection, photosIds: currentPhotoIds };
		}

		return currentSection;
	});
};

export const getPhotoSectionsStatus = (
	photos: Photo[],
	documentsValidation: DocsQuestionsState[] | null | undefined
): any => {
	const photoBySections: PhotoBySectionsType = {};
	const completedSection: CompletedSectionType = {};
	let requiredSection: RequiredSectionType = {};
	const sections = getPhotoSections(documentsValidation);
	sections.forEach((section) => {
		if (section.required) {
			requiredSection = { ...requiredSection, [section.sectionId]: true };
			photoBySections[section.sectionId] = [];
			section.photosIds?.forEach((id) => {
				photos.forEach((photo) => {
					if (id === photo.id) photoBySections[section.sectionId].push(photo);
				});
			});
		} else {
			requiredSection = { ...requiredSection, [section.sectionId]: false };
		}
	});

	for (const sectionId in photoBySections) {
		completedSection[sectionId] = photoBySections[sectionId]
			.filter((section) => section.required)
			.every((p) => p.awsUrl);
	}
	return { completedSection, requiredSection };
};
